export default "__VITE_ASSET__g05A88iH__"